<template>
  <div
    :id="`component_wrapper-${index_component}`"
    :data-primery-rabot-id="primery_rabot_data.primeryRabotId"
    contenteditable="false"
    data-name="primery_rabot"
    class="componentArticle_wrapper component_container primery-rabot-container"
    @dblclick="editPrimeryRabot"
  >
    <div class="componentArticle_wrapper__admin_controls-header">
      <CloseSVG
        alt="close"
        class="componentArticle_wrapper__admin_controls-header__img"
        @click="deletePrimeryRabot()"
      />
    </div>

    <div class="primery-rabot-preview">
      <template v-if="isLoading">
        <div class="primery-rabot-preview__loader">
          <v-progress-circular :size="24" color="#539ee0" indeterminate />
        </div>
      </template>

      <template v-else-if="!entry">
        <div class="primery-rabot-preview__empty">
          <v-icon color="orange" class="mr-1">mdi-alert</v-icon>
          <span>Примеры работ не найдены (ID: {{ primery_rabot_data.primeryRabotId }})</span>
        </div>
      </template>

      <template v-else>
        <div class="primery-rabot-preview__content">
          <div class="primery-rabot-preview__main">
            <img
              v-if="firstImageUrl"
              :src="firstImageUrl"
              class="primery-rabot-preview__main-img"
              alt=""
            />
            <div v-else class="primery-rabot-preview__no-img">
              <v-icon size="48" color="grey lighten-1">mdi-image-multiple</v-icon>
            </div>
<div class="primery-rabot-preview__overlay">
              <v-icon color="white" size="18" class="mr-1">mdi-image-multiple</v-icon>
              <span>{{ specsCount }} {{ specsLabel }}</span>
            </div>
          </div>
          <div class="primery-rabot-preview__info">
            <span class="primery-rabot-preview__name">{{ entry.name }}</span>
            <div class="primery-rabot-preview__thumbnails" v-if="thumbnails.length > 1">
              <v-img
                v-for="(thumb, i) in thumbnails.slice(0, 4)"
                :key="i"
                :src="thumb"
                class="primery-rabot-preview__thumb"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Request from "@/services/request";
import CloseSVG from "@/assets/svg/closeIcon.svg";

export default {
  name: "SpecificationArticle",
  components: { CloseSVG },
  data: () => ({
    index_component: null,
    index_primery_rabot: null,
    primery_rabot_data: {},
    entry: null,
    specs: [],
    isLoading: false,
  }),
  computed: {
    specsCount() {
      return this.specs.length;
    },
    specsLabel() {
      const n = this.specsCount;
      if (n === 1) return "фото";
      if (n >= 2 && n <= 4) return "фото";
      return "фото";
    },
    firstImageUrl() {
      return this.specs[0]?._image?.orig_path || null;
    },
    thumbnails() {
      return this.specs.map((s) => s._image?.orig_path).filter(Boolean);
    },
  },
  watch: {
    "$store.state.ArticleModule.selectedComponent": {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length && !this.primery_rabot_data.primeryRabotId) {
          this.getData();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const selected = this.$store.state.ArticleModule.selectedComponent;
      if (!selected || !Object.keys(selected).length) return;

      this.index_primery_rabot = this.$store.state.ArticleModule.counters.primery_rabot;
      this.index_component = this.$store.state.ArticleModule.counters.layout;
      this.primery_rabot_data = { ...selected };

      if (this.primery_rabot_data.primeryRabotId) {
        this.fetchEntry();
      }
    },

    async fetchEntry() {
      this.isLoading = true;
      try {
        const query = Request.modifyQuery([], ["*"]);
        const res = await Request.get(
          `${this.$store.state.BASE_URL}/entity/primery-rabot/${this.primery_rabot_data.primeryRabotId}${query}`
        );
        this.entry = res.data;
        await this.fetchSpecs();
      } catch (e) {
        console.error("Ошибка загрузки примеров работ:", e);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchSpecs() {
      const ids = this.entry?.ids_specifications || [];
      if (!ids.length) return;

      const query = Request.modifyQuery([], ["*", "_image"]);
      const results = await Promise.all(
        ids.map((id) =>
          Request.get(`${this.$store.state.BASE_URL}/entity/specifications/${id}${query}`)
        )
      );
      this.specs = results.filter((r) => !r.isError).map((r) => r.data);
    },

    editPrimeryRabot() {
      this.$store.commit("change_name_component", "primery_rabot");
      this.$store.commit("change_select_component", {
        name: "primery_rabot",
        value: true,
      });
      this.$store.commit("setEditingPrimeryRabot", {
        primeryRabotId: this.primery_rabot_data.primeryRabotId,
        index_component: this.index_component,
      });
    },

    async deletePrimeryRabot() {
      if (!confirm("Удалить блок примеров работ из статьи?")) return;
      this.$store.commit("clearEditingPrimeryRabot");
      await this.$store.dispatch("deleteComponent", this.index_component);
    },
  },
};
</script>

<style lang="scss" scoped>
.primery-rabot-container {
  position: relative;
  padding: 0;
  margin: 20px 0;
  background: #f5f5f5;
  border-radius: 8px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  overflow: hidden;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

    .primery-rabot-preview__overlay {
      opacity: 1;
    }
  }
}

.primery-rabot-preview {
  &__loader,
  &__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    color: #888;
    font-size: 14px;
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__main {
    position: relative;
    width: 100%;
    background: #e0e0e0;
  }

  &__main-img {
    width: 100%;
    height: auto;
    display: block;
  }

  &__no-img {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    width: 100%;
  }


  &__overlay {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, 0.65);
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    display: flex;
    align-items: center;
    opacity: 0;
    transition: opacity 0.2s;
  }

  &__info {
    padding: 10px 12px 8px;
    background: #fff;
  }

  &__name {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
  }

  &__thumbnails {
    display: flex;
    gap: 4px;
  }

  &__thumb {
    width: 52px;
    height: 40px;
    border-radius: 3px;
    background: #ddd;
    flex-shrink: 0;
  }
}
</style>